import { useEffect } from 'react';
import '../styles/NextEvent.scss';
import ContactUsForm from './ContactUsForm';

function NextEvent(props: { title: string }) {
  useEffect(() => {
    document.title = props.title;
  });
  return (
    <div className="next-event-page">
      <div className="event-desc">
        <p className="event-title">
          Have we piqued your curiosity for hi-tech, immersive experiences?
        </p>
        <p className="event-text">
          Alnair is just one example of the immersive experiences and solutions
          SoftServe creates. Using leading edge technology and our own talented
          teams, we are always finding new ways to help people and tech
          interact. If you’d like your colleagues to meet Alnair, or to talk to
          us about our other demos, please fill out the form and we’ll be in
          touch.
        </p>
      </div>
      <div className="form-container">
        <p className="request-title">Request demo</p>
        <ContactUsForm />
      </div>
    </div>
  );
}

export default NextEvent;
